import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation-top-header',
  templateUrl: './quotation-top-header.component.html',
  styleUrls: ['./quotation-top-header.component.scss']
})
export class QuotationTopHeaderComponent implements OnInit {
  currentDateTime: string = '';

  constructor() {}

  ngOnInit(): void {
    this.updateDateTime();
    setInterval(() => this.updateDateTime(), 1000); // Update every second
  }

  updateDateTime(): void {
    const now = new Date();
    const dateOptions: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    const date = now.toLocaleDateString('en-GB', dateOptions).replace(/,/, '');
    const time = now.toLocaleTimeString('en-GB', timeOptions);
    this.currentDateTime = `${date} ${time}`;
  }
}